module.exports = __webpack_public_path__ + "static/media/included.04912810.svg";